<template lang="pug">
v-app-bar.x-pagelet-action-bar(
  :elevation="0"
  :height="32"
  v-bind="{ ...$props, ...$attrs }"
  dense
)
  slot(name="navbar")

  v-toolbar-title.pl-1
    v-card-text.pl-0.py-4 {{ caption }}
    v-card-subtitle.pl-0.pb-2(v-if="description") {{ description }} &nbsp;

  v-spacer

  slot(name="left")

  //- Ações agrupáveis
  v-menu(
    v-for="(category, index) in pins.categories"
    :key="`menu-${category}`"
    offset-y
  )
    template(#activator="{ on, attrs }")
      v-btn(
        v-bind="attrs"
        v-on="on"
        text
        rounded
      )
        v-icon mdi-menu-down
        | {{ category }}
    v-list
      action-bar-menu-item(
        v-for="(action,index) in pins.links.filter(x => x.category === category)"
        :key="`menu-${category}-${index}`"
        :action="action"
        @perform="opts => $emit('perform', opts)"
      )

  //- Ações não agrupáveis
  action-bar-pin(
    v-for="(action,index) in pins.links.filter(x => !x.category)"
    :key="`pin-${index}`"
    :action="action"
    @perform="opts => $emit('perform', opts)"
  )

  slot(name="right")

  //- MENU DE AÇÕES
  //-
  v-menu(
    v-if="actions.length"
    bottom left offset-y
  )
    template(#activator="{ on, attrs }")
      v-btn.ml-1(
        icon
        v-bind="attrs"
        v-on="on"
      )
        v-icon mdi-dots-vertical

    v-list
      //- Ações não agrupáveis
      action-bar-menu-item(
        v-for="(action,index) in acts.links.filter(x => !x.category)"
        :key="`menu-${index}`"
        :action="action"
        @perform="opts => $emit('perform', opts)"
      )

      //- Ações agrupáveis
      template(v-for="(category, index) in acts.categories")
        v-subheader {{ category }}

        action-bar-menu-item(
          v-for="(action,index) in acts.links.filter(x => x.category === category)"
          :key="`menu-${category}-${index}`"
          :action="action"
          @perform="opts => $emit('perform', opts)"
        )

  //- BOTÃO DE ATUALIZAR
  v-tooltip(
    v-if="allowRefresh"
    bottom
  )
    template(#activator="{ on, attrs }")
      v-btn.mx-1(
        icon
        small
        v-bind="attrs"
        v-on="on"
        @click="$emit('refresh')"
      )
        v-icon(small) mdi-refresh
    span
      span.text-md.font-weight-medium Atualizar
      br
      span.font-weight-light Sincroniza os dados da página com o servidor de dados.

</template>

<style>
.x-pagelet-action-bar .v-toolbar__content {
  padding-left: 12px;
  padding-right: 0;
}
.x-btn-navbar {
  border: 1px solid #9995;
}
</style>

<script>
import { findRels } from '@/helpers/rels'
import ActionBarMenuItem from '@/components/commons/action-bar/ActionBarMenuItem'
import ActionBarPin from '@/components/commons/action-bar/ActionBarPin'

export default {
  components: {
    ActionBarMenuItem,
    ActionBarPin,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,   // @type {Keep.Paper.Design.pagelet}
    pagelet: Object,  // @type {Keep.Paper.Design.pagelet}

    busy: Boolean,
    allowRefresh: Boolean,
  },

  computed: {
    caption: vm => vm.title || vm.pagelet?.title || vm.pagelet?.name || vm.pagelet?.eref,
    description: vm => vm.pagelet?.description,

    links: vm => vm.pagelet?.links || [],
    actions: vm => findRels(vm.links, 'Action'),
    acts () {
      const links = [
        ...findRels(this.actions, 'Primary'),
        ...findRels(this.actions, 'Secondary'),
        ...findRels(this.actions, { excludes: [ 'Primary', 'Secondary' ] }),
      ]
      const categories = [ ...new Set( links.filter(x => !!x.category).map(x => x.category) ) ]
      return { categories, links }
    },
    pins () {
      const links = [
        ...findRels(this.actions, { includes: [ 'Pinned', 'Primary']}),
        ...findRels(this.actions, { includes: [ 'Pinned', 'Secondary' ]}),
        ...findRels(this.actions, { includes: [ 'Pinned' ], excludes: [ 'Primary', 'Secondary' ] }),
      ]
      const categories = [ ...new Set( links.filter(x => !!x.category).map(x => x.category) ) ]
      return { categories, links }
    },
  },
}
</script>
